var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"toggle",attrs:{"size":"small","type":"text"},on:{"click":_vm.toggle}},[_vm._v("\n\t"+_vm._s(_vm.value ? 'Hide Patients' : 'Show Patients')+"\n\t \n\t"),_c('i',{staticClass:"el-icon",class:_vm.value? 'el-icon-arrow-up': 'el-icon-arrow-down'})])
}
var staticRenderFns = []

export { render, staticRenderFns }